import environments from "../const/Environments";
import axios from "axios";
export function fetchRecommendedAddress(userToken, environment, payload, callback) {
  axios.post(environments.cartApi[environment] + '/v2/carts/v2/addressSuggestion', payload, {
    headers: {
      'Content-Type': 'application/json',
      'X-Authorization': userToken
    }
  }).then(function (response) {
    callback(response);
  }).catch(function (error) {
    callback(error);
  });
}